import { render, staticRenderFns } from "./offsetRecord.vue?vue&type=template&id=1b834672&scoped=true&"
import script from "./offsetRecord.vue?vue&type=script&lang=js&"
export * from "./offsetRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b834672",
  null
  
)

export default component.exports